export function SvgDropShadowText(props: React.SVGProps<SVGTextElement>) {
  return <text filter="url(#text-label-shadow)" {...props}></text>;
}

export function SvgDropShadowTextWhite(props: React.SVGProps<SVGTextElement>) {
  return <text filter="url(#text-label-shadow-white)" {...props}></text>;
}
